var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultipledelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9993 21.3335H25.3327V24.0002H19.9993V21.3335ZM19.9993 10.6668H29.3327V13.3335H19.9993V10.6668ZM19.9993 16.0002H27.9993V18.6668H19.9993V16.0002ZM3.99935 24.0002C3.99935 25.4668 5.19935 26.6668 6.66602 26.6668H14.666C16.1327 26.6668 17.3327 25.4668 17.3327 24.0002V10.6668H3.99935V24.0002ZM6.66602 13.3335H14.666V24.0002H6.66602V13.3335ZM13.3327 5.3335H7.99935L6.66602 6.66683H2.66602V9.3335H18.666V6.66683H14.666L13.3327 5.3335Z",
    fill: "#296BD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipledelete);
export default __webpack_public_path__ + "static/media/multiple delete.bfe31e362b0066cda44a04d3acbd5d72.svg";
export { ForwardRef as ReactComponent };